import React from 'react';
import { useTheme } from '../context/ThemeContext';

const Badge = ({ type = 'free' }) => {
  const { isDarkMode } = useTheme();
  
  const styles = {
    badge: {
      display: 'inline-block',
      padding: '4px 12px',
      fontSize: '0.9rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      border: `3px solid ${isDarkMode ? '#fff' : '#000'}`,
      boxShadow: `4px 4px 0 ${isDarkMode ? '#fff' : '#000'}`,
      transform: 'translate(-2px, -2px)',
      marginLeft: '12px',
      letterSpacing: '0.5px',
      ...type === 'premium' ? {
        backgroundColor: '#FFD700',
        color: '#000',
      } : {
        backgroundColor: isDarkMode ? '#333' : '#fff',
        color: isDarkMode ? '#fff' : '#000',
      }
    }
  };

  return (
    <span style={styles.badge}>
      {type === 'premium' ? 'PREMIUM' : 'GRATIS'}
    </span>
  );
};

export default Badge;